import { IFormValues } from '../../popups/MedicalNoteModal/form/types';

const createValues: IFormValues = {
  date: '',
  reason: '',
};

export default createValues;
